import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import type { ReachKpis } from '../chartTypes.ts';
import { parseKpi } from './utils.ts';

export const parseReachKpis = (response: HouseholdInsightsApiResponse | undefined): ReachKpis => ({
  households: parseKpi(response?.totals?.households),
  users: parseKpi(response?.totals?.users),
  ctvDevices: parseKpi(response?.totals?.ctv_devices),
});
